import React from "react";
import clsx from "clsx";
import Tooltip from "antd/lib/tooltip";
import { Consumer as IConsumer } from "Models/consumer";
import Line from "./Line";
import Head from "./Head";
import Consumer from "./Consumer";
import styles from "./ConsumerGroup.module.css";

type ConsumerGroupProps = {
    consumers: IConsumer[];
    name: string;
};

const ConsumerGroup = ({ name, consumers }: ConsumerGroupProps) => {
    return (
        <Tooltip title="Consumer group" placement="left">
            <div className={clsx(styles.root)}>
                <Line
                    direction="vertical"
                    length={(consumers.length - 1) * 40}
                    className={styles.line}
                />
                <Head text={name} className={styles.head} backgroundless />
                <div className={styles.consumers}>
                    {consumers.map((consumer) => (
                        <Consumer consumer={consumer} key={consumer.id} />
                    ))}
                </div>
            </div>
        </Tooltip>
    );
};

export default ConsumerGroup;
